import axios from 'axios';
import qs from "qs";
import { Message } from 'element-ui';
import router from '@/router';
import { hasAuthToken } from './pass';
import store from '../store';

// let cancel, promiseArr = {};

// 请求响应信息
const codeMessage = {
  200: '服务器成功返回请求的数据',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）',
  204: '删除数据成功。',
  400: '发出的请求有错误。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '没有操作权限，请联系管理员。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器',
  502: '网关错误',
  503: '服务不可用，服务器暂时过载或维护',
  504: '网关超时',
};

const service = axios.create({
  baseURL: '',
  // timeout: 5000,//请求超时时间
  // responseType:'json',//响应类型

  //是否该使用类似cookies,authorization headers(头部授权)或者TLS客户端证书这一类资格证书来创建一个跨站点访问控制（cross-site Access-Control）请求。
  //在同一个站点下使用withCredentials属性是无效的。
  // withCredentials: true, 
  headers: {
    "Content-Type": "application/json;charset=utf-8"//请求头相关配置;
  }
})

// 防篡改请求头
function getHeaders() {
  const timestamp = Date.now();
  const randomNum = Math.random().toString().slice(-8);
  const nonce = window.CryptoJS.MD5(timestamp + randomNum).toString();
  const sign = window.CryptoJS.MD5(`timestamp=${timestamp}&nonce=${nonce}&key=NQNsfdKRnq8I8m5nK6fwyBdw9sDLRClx`).toString();
  return {
    'X-Request-Timestamp': timestamp,
    'X-Request-Nonce': nonce,
    'X-Request-Signature': sign,
  }
}

//请求拦截
service.interceptors.request.use(config => {
  // console.log(config)
  Object.assign(config.headers, getHeaders())
  // 国际化请求头Internationalization
  config.headers.Internationalization = store.state.locale;
  // 携带请求头Authorization
  if (hasAuthToken(config.url))
    config.headers.Authorization = localStorage.getItem('authToken');
  if (config.method === 'get') {
    // 如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2,不转换会显示为arr[]=1&arr[]=2
    config.paramsSerializer = function (params) {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
  }
  return config;
}, err => {
  //错误处理
  return Promise.reject(err);
});

//响应拦截
service.interceptors.response.use(response => {
  if (response.data.code === 200) {
    //返回成功之后的处理
    return Promise.resolve(response);
  } else if (response.data.status === 'success') {
    return Promise.resolve(response);
  } else if (response.config.responseType === 'blob') {
    return response
  } else {
    // Message({
    //   message: response.data.return_info,
    //   type: 'error',
    //   duration: 2 * 1000
    // })
    return Promise.reject(response);
  }
}, err => {
  // console.log('axios error log', err.response)
  const { status } = err.response || {};
  // 未登录
  if (status == 401) {
    router.replace({ path: '/auth/login' });
  } else if (status == 404) { // 404
    router.replace({ path: '/pages/error404' });
  } else {
    // Message({
    //   showClose: true,
    //   message: codeMessage[status],
    //   type: 'error',
    //   duration: 2 * 1000
    // })
    console.error(codeMessage[status]);

  }
  return Promise.reject(err.response);
})

//get请求
export function get(url, params) {
  return new Promise((resolve, reject) => {
    service({
      method: 'get',
      url,
      params: params,
      // cancelToken: new CancelToken(c => {
      // 	cancel = c
      // })
    }).then(res => {
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export function downloadBlob(url, params) {
  return new Promise((resolve, reject) => {
    service({
      method: 'post',
      url,
      data: params,
      responseType: 'blob'
      // cancelToken: new CancelToken(c => {
      // 	cancel = c
      // })
    }).then(res => {
      // console.log(res);
      // 从响应头中提取文件名
      const contentDisposition = res.headers['content-disposition'];
      const filenameMatch = contentDisposition.match(/filename=(.+)/);
      const filename = filenameMatch ? filenameMatch[1] : 'default.zip';

      window.saveAs(res.data, filename);
    }).catch(err => {
      // Message({
      //   message: 'System error!',
      //   type: 'error',
      //   duration: 2 * 1000
      // })
      reject(err)
    })
  })
}

//download excel 请求
export function excel(url, params) {
  return new Promise((resolve, reject) => {
    service({
      method: 'get',
      url,
      params: params,
      responseType: 'blob'
      // cancelToken: new CancelToken(c => {
      // 	cancel = c
      // })
    }).then(res => {
      let blob = res.data;
      let reader = new FileReader();
      if (['application/vnd.ms-excel', 'text/csv'].includes(blob.type)) {
        reader.readAsDataURL(blob);
        reader.onload = (e) => {
          let a = document.createElement('a')
          a.download = params.name + (blob.type == 'text/csv' ? ".csv" : '.xlsx')
          a.href = e.target.result
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        }
      } else {
        reader.readAsText(blob, 'utf-8');
        reader.onload = function () {
          let result = JSON.parse(reader.result);
          if (result.code != 200) {
            Message({
              showClose: true,
              message: result.message,
              type: 'error',
              duration: 2 * 1000
            })
          }
        }
      }
    }).catch(err => {
      Message({
        message: 'System error!',
        type: 'error',
        duration: 2 * 1000
      })
      reject(err)
    })
  })
}

//post请求
export function post(url, params) {
  return new Promise((resolve, reject) => {
    service({
      method: 'post',
      url,
      // data: qs.stringify(params),
      data: params,
      // cancelToken: new CancelToken(c => {
      // 	cancel = c
      // })
    }).then(res => {
      // if (res.data.code === 401) {
      // 	alert('登录已超时，请重新登陆！')
      // 	this.$router.push('/login')
      // }
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}

export function postForm(url, params) {
  return new Promise((resolve, reject) => {
    service({
      method: 'post',
      url,
      data: params,
      // cancelToken: new CancelToken(c => {
      // 	cancel = c
      // })
    }).then(res => {
      // if (res.data.code === 401) {
      // 	alert('登录已超时，请重新登陆！')
      // 	this.$router.push('/login')
      // }
      resolve(res.data)
    }).catch(err => {
      reject(err)
    })
  })
}
